
import { defineComponent, PropType, computed } from "vue";
import { ChannelKPIs, GroupedAlert } from "@/stores/telegramAlerts";
import StakesHistogram from "./StakesHistogram.vue";
import StakesSummary from "./StakesSummary.vue";
import OddsRadar from "./OddsRadar.vue";
import OperationsPieChart from "./OperationsPieChart.vue";
import RiskRewardRadar from "./RiskRewardRadar.vue";

export default defineComponent({
  name: "AlertsKPIs",
  components: {
    StakesHistogram,
    StakesSummary,
    OddsRadar,
    OperationsPieChart,
    RiskRewardRadar,
  },
  props: {
    kpis: {
      type: Object as PropType<ChannelKPIs | null>,
      default: null,
    },
    alerts: {
      type: Array as PropType<GroupedAlert[]>,
      default: () => [],
    },
    alertType: {
      type: String,
      default: "sports_betting",
    },
  },
  setup(props) {
    const isSportsBetting = computed(() => {
      return props.alertType === "sports_betting";
    });

    const averageStake = computed(() => {
      if (!props.alerts || props.alerts.length === 0) return "0.0";

      let totalStake = 0;
      let count = 0;

      for (const alert of props.alerts) {
        if (alert.stake) {
          // Parse "1%" -> 1, "0.5%" -> 0.5, "1" -> 1
          const numericStake = parseFloat(alert.stake.replace("%", ""));
          if (!isNaN(numericStake)) {
            totalStake += numericStake;
            count++;
          }
        }
      }

      return count > 0 ? (totalStake / count).toFixed(1) : "0.0";
    });

    return {
      isSportsBetting,
      averageStake,
    };
  },
});
